<template>
  <img
    :src="avatar"
    :class="{
      'is-mini': (this.$props.size === 'mini'),
      'is-small': (this.$props.size === 'small'),
      'is-medium': (this.$props.size === 'medium')
    }"
  >
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    avatar: function () {
      if (this.$user.instance) {
        return `https://www.gravatar.com/avatar/${this.$user.instance.email_hash}?d=mm&s=125`
      }
      return `https://www.gravatar.com/avatar/?d=mm&s=125`
    }
  }
}
</script>

<style lang="scss" scoped>
  $avatar-img-width: 125px !default;
  $avatar-img-border-radius: $avatar-img-width !default;

  img {
    width: $avatar-img-width;
    border-radius: $avatar-img-border-radius;

    &.is-mini {
      width: calc(#{$avatar-img-width} / 4);
      border-radius: calc(#{$avatar-img-border-radius} / 4);
    }

    &.is-small {
      width: calc(#{$avatar-img-width} / 3);
      border-radius: calc(#{$avatar-img-border-radius} / 3);
    }

    &.is-medium {
      width: calc(#{$avatar-img-width} / 2);
      border-radius: calc(#{$avatar-img-border-radius} / 2);
    }
  }
</style>
